/*
  assets/pdp-price-sync.js — V6.9 (2026-08-06)

  Stress-test finding #5: on a product with subscription options, choosing
  "Subscribe & save" updated the Seal Subscriptions widget (A$134.99) but the theme's
  main price block above it still read $149.99. The shopper saw two different prices for
  the thing they were about to add, and the one in the larger, more prominent position
  was the wrong one.

  The widget is Seal Subscriptions (.sealsubs-container). Its selected option lives in
  the hidden input[name="selling_plan"], and each .sls-option-container renders its own
  price. This mirrors the selected option's price into the theme's price block(s)
  ([id^="price-template"]) and restores the original markup when the shopper switches
  back to a one-time purchase.

  Defensive by design: if the widget isn't present, or the markup changes shape, every
  lookup fails closed and the price block is left exactly as the theme rendered it.
*/
(function () {
  'use strict';

  var MONEY_RE = /(?:[A-Z]{0,3}\s*)?([$€£¥]\s?[\d,]+(?:\.\d{2})?)/g;

  function priceBlocks() {
    return document.querySelectorAll('[id^="price-template"]');
  }

  // Which nodes hold the price the shopper actually pays.
  // On a sale product Dawn renders the compare-at as `s.price-item--regular` INSIDE
  // `.price__sale`, so that one must be left alone or the strikethrough gets clobbered.
  function priceTargets(block) {
    var targets = [];
    block.querySelectorAll('.price-item--sale').forEach(function (el) {
      targets.push(el);
    });
    block.querySelectorAll('.price-item--regular').forEach(function (el) {
      if (!el.closest('.price__sale')) targets.push(el);
    });
    return targets;
  }

  // Last money-looking token in a string, normalised to the theme's display form
  // ("A$134.99" -> "$134.99") so it sits consistently next to the rest of the page.
  function lastMoney(text) {
    if (!text) return null;
    var match;
    var found = null;
    MONEY_RE.lastIndex = 0;
    while ((match = MONEY_RE.exec(text)) !== null) {
      found = match[1];
    }
    return found ? found.replace(/\s+/g, '') : null;
  }

  function selectedOption() {
    var containers = document.querySelectorAll('.sls-option-container');
    for (var i = 0; i < containers.length; i++) {
      var radio = containers[i].querySelector('input[type="radio"]');
      if (radio && radio.checked) return containers[i];
    }
    return null;
  }

  function isSubscription() {
    var hidden = document.querySelector('.sealsubs-container input[name="selling_plan"]');
    if (hidden && hidden.value) return true;
    var container = selectedOption();
    if (!container) return false;
    var radio = container.querySelector('input[type="radio"]');
    return !!(radio && radio.value && radio.value !== 'one_time');
  }

  function apply() {
    var blocks = priceBlocks();
    if (!blocks.length) return;

    // Mirror whichever option is selected — one-time included. Doing it symmetrically
    // (rather than "modify for subscriptions, restore a snapshot for one-time") means
    // there is no saved copy that can go stale when the app re-renders its widget, which
    // is what left the price stuck on the subscription figure after switching back.
    var container = selectedOption();
    if (!container) return; // widget not ready — leave the theme's own markup alone
    var price = lastMoney(container.innerText || container.textContent);
    if (!price) return;

    var subscription = isSubscription();

    // Cadence, if the widget exposes one ("Deliver every 2 months").
    var cadence = '';
    if (subscription) {
      var cadenceSelect = document.querySelector('select[name="subs_interval"]');
      if (cadenceSelect && cadenceSelect.options[cadenceSelect.selectedIndex]) {
        cadence = (cadenceSelect.options[cadenceSelect.selectedIndex].text || '').trim();
      }
    }

    blocks.forEach(function (block) {
      var targets = priceTargets(block);
      if (!targets.length) return;
      targets.forEach(function (el) {
        if (el.textContent.trim() !== price) el.textContent = price;
      });

      var note = block.querySelector('.pdp-price__plan-note');
      if (subscription) {
        if (!note) {
          note = document.createElement('span');
          note.className = 'pdp-price__plan-note';
          block.appendChild(note);
        }
        note.textContent = cadence
          ? 'Subscription — every ' + cadence.replace(/^every\s+/i, '')
          : 'Subscription price';
      } else if (note && note.parentNode) {
        note.parentNode.removeChild(note);
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      try {
        apply();
      } catch (e) {
        /* never let a price widget break the page */
      }
    });
  }

  function watch() {
    var widget = document.querySelector('.sealsubs-container');
    if (!widget) return false;
    schedule();
    // Seal re-renders its own DOM on selection, so observe rather than bind to a node.
    new MutationObserver(schedule).observe(widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'class']
    });
    return true;
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.sealsubs-container')) schedule();
  });

  function boot() {
    if (watch()) return;
    // The widget is injected by the app, often after DOMContentLoaded — wait for it,
    // then stop watching so we aren't observing the whole document forever.
    var observer = new MutationObserver(function () {
      if (watch()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
